type EnvKey =
  | 'REACT_APP_API_URL'
  | 'REACT_APP_KEYCLOAK_URL'
  | 'REACT_APP_KEYCLOAK_REALM'
  | 'REACT_APP_KEYCLOAK_CLIENT_ID'
  | 'REACT_APP_ENV';

declare global {
  interface Window {
    _env_?: Partial<Record<EnvKey, string>>;
  }
}

export const getEnv = (key: EnvKey, fallback = ''): string =>
  window._env_?.[key] || process.env[key] || fallback;
